import util from '../util'

let controller = 'Movimentos'
export default {
  ExisteMovimento: function (dto) {
    return util.Axios.GetAll(controller + '/ExisteMovimento', dto)
  }
}
